import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'
import classnames from 'classnames'
import { TabContentData } from './TabContentData'
import { MilestoneLogsActions } from '../../actions';
import { DateWiteContentData } from './DateWiteContentData'

import { MilestoneData2 } from '../DashBoard/DashboardCards';

const TABS = {
    NumberWise: "NumberWise",
    DateWise: "DateWise",
}

class MilestoneLogs extends Component {
    constructor(props) {
        super(props)

        this.state = {
            activeTab: TABS.NumberWise,
            page: {
                activePage: 1,
                perPage: 20,
                totalItemsCount: 0
            }
        }

        this.toggle = this.toggle.bind(this)
        this.getMilestoneLogs = this.getMilestoneLogs.bind(this)
    }

    componentDidMount() {
        this.getMilestoneLogs();
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            }, function () {
                this.getMilestoneLogs();
            })
        }
    }

    getMilestoneLogs() {
        const { dispatch } = this.props;
        const { page } = this.state;
        let dataToSend = {
            active_page: page.activePage,
            per_page: page.perPage,
            log_type: this.state.activeTab
        }
        dispatch(MilestoneLogsActions.getMilestoneLogs(dataToSend));
    }

    render() {
        const { data, loading } = this.props;

        console.log(data);
        return (
            <div>
                <h5 className="mb-4 mt-4">
                    <i className="fas fa-bug"></i> &nbsp; Milestone Logs
                </h5>

                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === TABS.NumberWise })}
                            onClick={() => { this.toggle(TABS.NumberWise) }}
                        >
                            <b>Number Wise</b>

                        </NavLink>
                    </NavItem>
                    <NavItem>

                        <NavLink
                            className={classnames({ active: this.state.activeTab === TABS.DateWise })}
                            onClick={() => { this.toggle(TABS.DateWise) }}
                        >
                            <b>Date Wise</b>

                        </NavLink>
                    </NavItem>

                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={TABS.NumberWise}>
                    {this.state.activeTab === TABS.NumberWise &&
                        <TabContentData loading={loading} logs={data} isDateWise={true} activeTab={this.state.activeTab} /> 
                    }
                    </TabPane>
                    <TabPane tabId={TABS.DateWise}>
                        {this.state.activeTab === TABS.DateWise &&  data  && <MilestoneData2 loading={loading}
							data={data}
						/>} 
                    </TabPane>
                </TabContent>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { loading, data } = state.getMilestoneLogs;
    return {
        loading,
        data
    }
}
const connectedMilestoneLogs = connect(mapStateToProps)(MilestoneLogs)
export { connectedMilestoneLogs as MilestoneLogs }
